import { TypeMap } from '../Common'
import { accountTeamMemberFieldsMapSF } from './AccountTeamMember'
import { actionFieldsMapSF } from './Action'
import { applicationFieldsMapSF, IncludeRelationshipsForApplication } from './Application'
import { applicationTeamMemberMapSF } from './ApplicationTeamMember'
import { caseFieldsMapSF } from './Case'
import { configurationFieldsMapSF } from './Configuration'
import { contentDocumentLinkFieldsMapSF } from './ContentDocumentLink'
import { contentVersionFieldsMapSF } from './ContentVersion'
import { errorLogFieldsMapSF } from './ErrorLog'
import { externalApprovalMapSF } from './ExternalApproval'
import { formPageFieldsMapSF } from './FormPage'
import { fundingProgramFieldsMapSF } from './FundingProgram'
import { fundingStreamFieldsMapSF } from './FundingStream'
import { granteeBudgetCategoryFieldsMapSF } from './GranteeBudgetCategory'
import { granteeReportFieldsMapSF } from './GranteeReport'
import { myShelfMapFields } from './MyShelf'
import { networkFieldsMapSF } from './Network'
import { reportRecordTypesFieldsMapSF } from './ReportRecordTypes'
import { reviewAssignementFieldsMapSF } from './ReviewAssignement'
import { surveyTextFieldsMapSF } from './SurveyText'
import { surveyTranslationFieldsMapSF } from './SurveyTranslation'

export type FieldMap = Record<string, any>

export const objectTypeMappingForSalesforce: Record<keyof TypeMap, string> = {
  Network: 'Network',
  Action: 'Action__c',
  'My Shelf': 'My_Shelf__c',
  'Content Document Link': 'ContentDocumentLink',
  'Content Version': 'ContentVersion',
  SurveyTranslation: 'SurveyTranslation__c',
  SurveyText: 'Survey_Text__c',
  FormPage: 'Form_Page__c',
  'Funding Stream': 'Funding_Stream__c',
  'Funding Program': 'Funding_Program__c',
  Configuration: 'Configuration__c',
  'Grantee Budget Category': 'FGM_Portal__Grantee_Budget_Category__c',
  'Report Record Types': 'FGM_Base__Grantee_Report__c',
  'Grantee Report': 'FGM_Base__Grantee_Report__c',
  'Error Log': 'Error_Tracking__c',
  Application: 'Opportunity',
  'Application Team Member': 'OpportunityTeamMember',
  Case: 'Case',
  'Review Assignement': 'Review_Assignement__c',
  'Account Team Member': 'AccountTeamMember',
  'External Approval': 'External_Approval__c',
  Account: 'Account'
}

export const typeMappingForIncludeRelationships = {
  Application: IncludeRelationshipsForApplication
} as const satisfies Partial<Record<keyof TypeMap, readonly string[]>>

const accountFieldMapPlaceholder: FieldMap = {}

export const fieldMapsByType = {
  Network: networkFieldsMapSF,
  'My Shelf': myShelfMapFields,
  Configuration: configurationFieldsMapSF,
  Action: actionFieldsMapSF,
  'Content Version': contentVersionFieldsMapSF,
  'Content Document Link': contentDocumentLinkFieldsMapSF,
  SurveyTranslation: surveyTranslationFieldsMapSF,
  SurveyText: surveyTextFieldsMapSF,
  FormPage: formPageFieldsMapSF,
  'Funding Stream': fundingStreamFieldsMapSF,
  'Funding Program': fundingProgramFieldsMapSF,
  'Grantee Budget Category': granteeBudgetCategoryFieldsMapSF,
  'Report Record Types': reportRecordTypesFieldsMapSF,
  'Grantee Report': granteeReportFieldsMapSF,
  'Review Assignement': reviewAssignementFieldsMapSF,
  'Error Log': errorLogFieldsMapSF,
  Application: applicationFieldsMapSF,
  'Application Team Member': applicationTeamMemberMapSF,
  'Account Team Member': accountTeamMemberFieldsMapSF,
  Case: caseFieldsMapSF,
  'External Approval': externalApprovalMapSF,
  Account: accountFieldMapPlaceholder
} as const satisfies Record<keyof TypeMap, any>

export interface IncludeRelationshipFields {
  'External_Approvals__r': Exclude<keyof typeof externalApprovalMapSF, 'direction'> | '*'
  'OpportunityTeamMembers': Exclude<keyof typeof applicationTeamMemberMapSF, 'direction'> | '*'
}
